import { isBrowser } from '@doltech/utils/lib/platform';
import * as React from 'react';

import { LANDING_HEADER_HEIGHT, SEO_TEST_HEADER_SECTION_SPACING } from '../constants';
import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';
import { setScrollYOf } from '@doltech/core/lib/hooks/useScrollElement';

export const useScrollToLocationHashOnMount = () => {
  const { appScrollRef } = useAppScrollRef();
  React.useEffect(() => {
    if (isBrowser()) {
      setTimeout(() => {
        const containerElm = appScrollRef.current;
        if (window.location.hash.length > 0) {
          const oriHash = window.location.hash;
          const elm = document.getElementById(oriHash.replace('#', ''));
          if (elm && containerElm) {
            setScrollYOf(
              containerElm,
              elm.offsetTop - LANDING_HEADER_HEIGHT - SEO_TEST_HEADER_SECTION_SPACING
            );
          }
          return;
        }
        setScrollYOf(containerElm, 0);
      }, 400);
    }
  }, [appScrollRef]);
};

export const scrollToLocationHashOnMountWithBlog = (appScrollRef) => {
  if (isBrowser()) {
    setTimeout(() => {
      const containerElm = appScrollRef.current;
      if (window.location.hash.length > 0) {
        const oriHash = window.location.hash;
        const elm = document.getElementById(oriHash.replace('#', ''));
        if (elm && containerElm) {
          setScrollYOf(containerElm, window.screenY + elm.getBoundingClientRect().top - 180);
        }
        return;
      }
      setScrollYOf(containerElm, 0);
    }, 400);
  }
};
